<template>
  <svg
    v-if="!outlined"
    width="23"
    height="26"
    viewBox="0 0 23 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1631 15.0243H4.44434V13.4146H16.4702C18.0388 13.4146 18.0388 12.3415 18.0388 12.3415L18.9956 3.48818C19.0067 3.38697 18.9968 3.28451 18.9666 3.18749C18.9364 3.09047 18.8867 3.00107 18.8206 2.92512C18.7544 2.84917 18.6735 2.78838 18.5829 2.74672C18.4924 2.70506 18.3943 2.68346 18.295 2.68333H4.44434V1.07364C4.44434 0.789027 4.33416 0.516071 4.13804 0.31482C3.94193 0.113569 3.67596 0.000508766 3.39862 0.000508766H1.35943C1.13384 -0.00649954 0.911741 0.0590455 0.724236 0.187966C0.53673 0.316886 0.393197 0.50273 0.313706 0.719504C0.258422 0.88178 0.241943 1.05532 0.265645 1.2255C0.289346 1.39568 0.352543 1.55751 0.449911 1.6974C0.547279 1.83729 0.675963 1.95113 0.825145 2.02933C0.974327 2.10753 1.13965 2.1478 1.30716 2.14677H2.35289V15.196C1.67468 15.4211 1.08258 15.8592 0.660346 16.4485C0.238107 17.0378 0.0071017 17.7484 0 18.4798C0.00374092 19.3983 0.355654 20.2793 0.9812 20.9362C1.60675 21.5932 2.45684 21.9746 3.35158 21.9997C3.91505 22.0077 4.47164 21.8718 4.97123 21.6042C5.47082 21.3367 5.89773 20.9458 6.21354 20.4669C6.52936 19.9879 6.72412 19.4359 6.78038 18.8605C6.83664 18.2851 6.7526 17.7044 6.5358 17.1706H12.0259C11.7453 17.8615 11.6888 18.6268 11.8648 19.3532C12.0407 20.0797 12.4397 20.7287 13.0029 21.2045C13.566 21.6803 14.2634 21.9575 14.9919 21.9952C15.7204 22.033 16.4414 21.8291 17.0483 21.4139C17.6552 20.9987 18.1158 20.3941 18.3621 19.6895C18.6084 18.9849 18.6272 18.2177 18.4158 17.5013C18.2045 16.7849 17.7741 16.1573 17.1883 15.7112C16.6026 15.2651 15.8925 15.0243 15.1631 15.0243ZM3.72279 19.8105C3.44508 19.8823 3.1521 19.8585 2.88884 19.7428C2.62558 19.6271 2.40662 19.4259 2.26564 19.1701C2.12465 18.9143 2.0694 18.618 2.10843 18.3269C2.14747 18.0357 2.27862 17.7658 2.48169 17.5586C2.68475 17.3513 2.94849 17.2183 3.23241 17.1798C3.51634 17.1414 3.80473 17.1997 4.05322 17.3458C4.30171 17.4919 4.49659 17.7177 4.60787 17.9885C4.71915 18.2593 4.74071 18.5601 4.6692 18.8447C4.61056 19.078 4.49172 19.2909 4.32518 19.4609C4.15865 19.6308 3.95054 19.7516 3.72279 19.8105ZM15.4872 19.8105C15.2095 19.8823 14.9165 19.8585 14.6533 19.7428C14.39 19.6271 14.1711 19.4259 14.0301 19.1701C13.8891 18.9143 13.8338 18.618 13.8729 18.3269C13.9119 18.0357 14.0431 17.7658 14.2461 17.5586C14.4492 17.3513 14.7129 17.2183 14.9969 17.1798C15.2808 17.1414 15.5692 17.1997 15.8177 17.3458C16.0662 17.4919 16.261 17.7177 16.3723 17.9885C16.4836 18.2593 16.5052 18.5601 16.4336 18.8447C16.375 19.078 16.2562 19.2909 16.0896 19.4609C15.9231 19.6308 15.715 19.7516 15.4872 19.8105Z"
      :fill="color"
      transform="scale(1.1)"
    />
   
  </svg>
  <svg
    v-else
    id="Component_420_1"
    data-name="Component 420 – 1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      id="Path_5930"
      data-name="Path 5930"
      d="M0,0H24V24H0Z"
      fill="none"
    />
    <circle
      id="Ellipse_317"
      data-name="Ellipse 317"
      cx="2"
      cy="2"
      r="2"
      transform="translate(4 17)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <circle
      id="Ellipse_318"
      data-name="Ellipse 318"
      cx="2"
      cy="2"
      r="2"
      transform="translate(15 17)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_5931"
      data-name="Path 5931"
      d="M17,17H6V3H4"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_5932"
      data-name="Path 5932"
      d="M6,5,20,6l-1,7H6"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  props: {
    outlined: {
      type: Boolean,
      default: false,
    },
    baseColor: {
      type: String,
      default: '#8B8B8B',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isOptIn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    color() {
      return this.isActive ? '#009A44'
        : this.isOptIn ? '#000000'
          : '#4B5563';
    },
  },
};
</script>